var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showFooter
    ? _c(
        "div",
        { ref: "bottomSection", staticClass: "extend-to-bottom" },
        [
          _c("v-dialog"),
          _vm._v(" "),
          _c("BaseActions", {
            staticClass: "margin-bottom",
            attrs: { actions: _vm.getCheckoutActionsBottom() }
          }),
          _vm._v(" "),
          _c("order-button")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54626b2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54626b2c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/MobileCheckoutFooter.vue
// module id = null
// module chunks = 